<div role="group" [ngClass]="styles.multiSelectGroup">
	<button type="button" vbUiBtnSecondary [ngClass]="(value && value[mk]) ? [styles.activeBtn, styles.multiSelectButton] : styles.multiSelectButton" [disabled]="disabled" *ngFor="let mk of modelKeys" (click)="onClick(mk)">
		{{ labelMap[mk] }}
	</button>
</div>
